const INFO = {
	main: {
		title: "Wessam Yaacob",
		name: "Wessam Yaacob",
		email: "wessamsalah@live.com",
		logo: "../me.webp",
	},

	socials: {
		github: "https://github.com/wessamyaacob/",
		linkedin: "https://www.linkedin.com/in/wessam-yaacob/",
		stackoverflow: "https://stackoverflow.com/users/7122286/wessam-yaacob/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		name: "Wessam Yaacob",
		title: "Senior Full-stack (.NET Core/Angular) Web and Cloud developer",
		description:
			"I'm a Senior Full Stack Developer with over 9 years of experience in building robust, scalable applications using technologies such as Angular, .NET, and AWS. My expertise spans across both frontend and backend development, with a strong focus on delivering high-quality, secure, and efficient solutions. I have a proven track record of leading teams, managing complex projects, and implementing clean architecture and best practices. Throughout my career, I’ve worked on a wide range of projects, from migration efforts (AngularJS to Angular 12) to developing cloud-based solutions with AWS. I’m passionate about solving problems and constantly enhancing my skill set, especially in areas like secure coding, AI, and cloud technologie.",
	},

	experiences: [
		{
			id: 1,
			company: "Wolters Kluwer Enablon",
			position: "Senior Product Software Engineer",
			date: "2020 - Present",
			location: "Den Haag, Netherlands",
			logo: "wk.jfif",
			responsibilities: [
				"Leveraged WebAssembly to reuse existing backend logic in a Angular + TypeScript editor, avoiding a full rewrite and reducing feature development time by 40%.",
				"Implemented secure REST APIs using .NET Core, Open ID Connect allowing integration between the platform products and external clients.",
				"Redesigned core application architecture to support multi-tenant SaaS models, improving scalability and reducing operational costs.",
				"Built CI/CD automation using GitHub Actions with canary rollout strategies, reducing deployment time by 75%.",
				"Implemented Infrastructure-as-Code using Terraform, reducing environment setup time by 95% and achieving near-zero configuration drift.",
				"Developed a decoupled microservice layer using Azure Service Bus and Azure Functions to orchestrate efficient, asynchronous communication across platform products.",
				"Tech: .NET Core 8, Azure, Angular, TypeScript, SQL, Github Actions, Terraform, Docker"
			]
		},
		{
			id: 2,
			company: "ICT Group",
			position: "Mid-Level Software Engineer",
			date: "2018 - 2020",
			location: "Eindhoven, Netherlands",
			logo: "ict.png",
			responsibilities: [
				"Automated file-processing using Azure Functions, converting uploaded files into a unified data model and cutting manual review by 50%.",
				"Refactored the file-processing workflow into an optimized SQL-driven data model, improving system performance by 50%.",
				"Built real-time messaging with Socket.io to track mobile device signals, allowing clients to monitor in real time and respond instantly.",
				"Led the rewrite of legacy web app in Angular/TypeScript, delivering fully customizable dashboards and cutting deployment friction by 100%.",
				"Containerized key services with Docker, improving environment consistency and enabling faster deployments through GitHub Actions.",
				"Tech: Azure, .NET Core, Angular, TypeScript, SQL, Github Actions, Docker, Socket.io"
			]
		},
		{
			id: 3,
			company: "52ndSolution",
			position: "Full Stack Software Engineer",
			date: "2017 - 2018",
			location: "Remote, Australia",
			logo: "52nd.jfif",
			responsibilities: [
				"Replaced a manual, booking process by developing Web application, improving coordination between clients, translators, and interpreters.",
				"Solved inconsistent billing and revenue tracking by building an invoicing and payments module, reducing manual accounting efforts.",
				"Eliminated financial data mismatches by integrating the accounting module with Xero, enabling real-time synchronization and reducing reconciliation errors.",
				"Implemented a CI/CD pipeline enabling incremental bi-weekly deployments with rollback options, reducing deployment failures.",
				"Tech: .NET/C#, Azure, Angular, TypeScript, SQL, TeamCity, Octopus"
			]
		},
		{
			id: 4,
			company: "GET Group",
			position: "Software Developer",
			location: "Cairo, Egypt",
			date: "2015 - 2017",
			logo: "get_group.jfif",
			responsibilities: [
				"Developed and maintained a comprehensive web portal for vehicle data statistics using ASP.NET MVC with Razor, Kendo UI.",
				"Implemented a mobile application for outdoor employee work attendance tracking with time and location features using Cordova.",
				"Tech: .NET, jQuery, SQL, Cordova",
			]
		}
	],

	logos: {
		"Angular": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg",
		"Typescript": "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/typescript/typescript.png",
		"AWS": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
		".NET Core": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dotnetcore/dotnetcore-original.svg",
		"Azure": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg",
		"React": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
		"C#": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/csharp/csharp-original.svg",
		"Python": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
		"TeamCity": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/TeamCity_Icon.svg/512px-TeamCity_Icon.svg.png?20200803084943",
		"GithubActions": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/githubactions/githubactions-original.svg",
		"Node": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
		"Docker": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
		"Postgres": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
		"WASM": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/wasm/wasm-original.svg",
		"SQL": "https://symbols.getvecta.com/stencil_28/61_sql-database-generic.90b41636a8.svg"
	},

	faIcons: {
		"gauge": "fa-solid fa-gauge",
		"map": "fa-solid fa-map",
		"settings": "fa-solid fa-gear",
		"users": "fa-solid fa-user",
		"chart": "fa-solid fa-chart-simple",
	},

	icons: {
		"gauge": "📡",
		"map": "🗺️",
		"settings": "⚙️",
		"users": "👥",
		"chart": "📉",
		"table": "📋",
		"real_time": "⏱️",
		"roles": "🔐",
		"data": "🗃️",
		"shield": "🛡️",
		"code": "💻",
		"refresh": "🔄",
		"bug": "🐞",
		"upload": "⬆️",
		"analytics": "📊",
		"plus-circle": "➕",
		"shopping-cart": "🛒",
		"file-invoice": "🧾",
		"calendar": "📅",
		"dollar-sign": "💲"
	},
};

export default INFO;
